(ns css.typography
  (:require
    [css.core :as css :refer [defstyled]]
    [cljss.core :as cljss]
    [css.vars :as vars]))

(defstyled h1 :h1
  {:color vars/title
   :font-size "2.27rem"
   :font-weight "300"
   :line-height "2.7rem"
   :margin (with-meta #(or % "4.5rem 0 2.5rem") :margin)
   :text-align (with-meta #(or % "left") :text-align)
   ::cljss/media {[[:max-width "1200px"]]
                  {:margin "2.5rem 0"}}})

(defstyled h2 :h2
  {:font-size "1.6rem"
   :font-weight (with-meta #(or % 400) :font-weight)
   :color (with-meta #(or % "inherit") :color)
   :line-height (with-meta #(or % "2.8rem") :line-height)
   :margin (with-meta #(or % 0) :margin)
   :padding (with-meta #(or % 0) :padding)})


(defstyled h3 :h3
  {:color (with-meta #(or % vars/text) :color)
   :font-size "1.6rem"
   :font-weight 400
   :line-height (with-meta #(or % "2.8rem") :line-height)})


(defstyled h4 :h4
  {:color (with-meta identity :color)
   :font-size "1rem"
   :font-weight (with-meta #(or % 700) :font-weight)
   :line-height (with-meta #(or % "1.2rem") :line-height)
   :padding (with-meta identity :padding)})

(defstyled text :p
  {:font-size (with-meta #(cond
                            (= % "large") "1.25rem"
                            (= % "normal") "0.9375rem"
                            (= % "small") ".88rem"
                            :else "1rem") :size)
   :width (with-meta #(or % "auto") :width)
   :font-weight (with-meta #(or % "400") :font-weight)
   :max-width (with-meta #(or % "100%") :max-width)
   :color (with-meta #(or % vars/text-light) :color)
   :margin (with-meta #(or % "0") :margin)
   :text-align (with-meta #(or % "left") :text-align)
   :line-height (with-meta #(or % "1.6rem") :line-height)})
